import React from "react";
import { formatMoney } from "../../../helper/formatter";

const TotalizadoresDetalle = ({ totalizadores }) => {
    return (
        <div className="invoice">
            <div className="invoice-content">
                <div className="invoice-price">
                    <div className="invoice-price-left">
                        <div className="invoice-price-row">
                            <div className="sub-price">
                                <small>SUBTOTAL</small>
                                <span className="text-dark"> {formatMoney(totalizadores.suma_venta_sujeta)} </span>
                            </div>

                            {totalizadores.iva > 0 ? (
                                <>
                                    <div className="sub-price">
                                        <i className="fa fa-plus text-muted"></i>
                                    </div>
                                    <div className="sub-price">
                                        <small>IVA (13%)</small>
                                        <span className="text-dark"> {formatMoney(totalizadores.iva)}</span>
                                    </div>
                                </>
                            ) : null}

                            {totalizadores.retencion > 0 ? (
                                <>
                                    <div className="sub-price">
                                        <i className="fa fa-minus text-muted"></i>
                                    </div>
                                    <div className="sub-price">
                                        <small>IVA Retenido(1%)</small>
                                        <span className="text-dark">{formatMoney(totalizadores.retencion)}</span>
                                    </div>
                                </>
                            ) : null}

                            {totalizadores.suma_venta_excenta > 0 ? (
                                <>
                                    <div className="sub-price">
                                        <i className="fa fa-plus text-muted"></i>
                                    </div>
                                    <div className="sub-price">
                                        <small>Vtas Excentas</small>
                                        <span className="text-dark"> {formatMoney(totalizadores.suma_venta_excenta)} </span>
                                    </div>
                                </>
                            ) : null}

                            {totalizadores.suma_venta_no_sujeta > 0 ? (
                                <>
                                    <div className="sub-price">
                                        <i className="fa fa-plus text-muted"></i>
                                    </div>
                                    <div className="sub-price">
                                        <small>Vtas No Sujetas</small>
                                        <span className="text-dark"> {formatMoney(totalizadores.suma_venta_no_sujeta)} </span>
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </div>
                    <div className="invoice-price-right">
                        <small>TOTAL</small> <span className="fw-bold">{formatMoney(totalizadores.total)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TotalizadoresDetalle;
